// extracted by mini-css-extract-plugin
module.exports = {"select":"styles-module__select___qIDt9","search-input-sm":"styles-module__search-input-sm___3JrZU"};